module.exports = __webpack_public_path__ + "img/advantageBlue.b27ac3fd.jpg";